import React from "react";
import { shortcutEvents } from "./events";
import { type ShortcutData, type ShortcutDataWithRef, type ShortcutTypes } from "./models";
import { usePrevious } from "utilities";

const stringifyWithFunctions = (_, value) =>
  typeof value === "function" ? value.toString() : value;

export const useShortcutPanel = (shortcut: ShortcutData) => {
  const refToScrollTo = React.useRef<HTMLDivElement>();
  const lastData = usePrevious(JSON.stringify(shortcut, stringifyWithFunctions));

  React.useEffect(() => {
    if (JSON.stringify(shortcut, stringifyWithFunctions) !== lastData) {
      shortcutEvents.updateShortcut({
        ...shortcut,
        refToScrollTo
      });
    }
  }, [shortcut]);

  return {
    refToScrollTo
  };
};

export const useGetShortcutData = (order: ShortcutTypes[]) => {
  const [shortcutData, setShortcutData] = React.useState<ShortcutDataWithRef[]>([]);

  React.useEffect(() => {
    const removeListener = shortcutEvents.listen((shortcutData) => {
      setShortcutData((prev) => {
        const index = prev.findIndex(shortcut => shortcut.label === shortcutData.label);
        if (index === -1) {
          return [...prev, shortcutData];
        } else {
          const newData = [...prev];
          newData[index] = shortcutData;
          return newData;
        }
      });
    });

    return removeListener;
  }, []);

  const orderedShortcutData = [...shortcutData];
  orderedShortcutData.sort((shortcutA, shortcutB) => {
    const aIndex = order.findIndex(type => type === shortcutA.type);
    const bIndex = order.findIndex(type => type === shortcutB.type);
    return aIndex - bIndex;
  });

  return orderedShortcutData;
};